import React from 'react';
import PageMeta from '../../components/common/PageMeta';
import FeatureImgThree from '../../components/features/FeatureImgThree';
import IntegrationTwo from '../../components/integration/IntegrationTwo';
import Promo from '../../components/promo/Promo';
import FooterOne from '../../layout/Footer/FooterOne';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
import HeroThree from './HeroThree';

const HomeDesktopApp = () => {
  return (
    <Layout>
      <PageMeta title='Desktop App - Software &amp; IT Solutions HTML Template' />
      <Navbar classOption='navbar-light' />
      <HeroThree />
      <Promo />
      {/* <FeatureImgThree paddingTop /> */}
      <IntegrationTwo />
      <FooterOne
        style={{
          background: "url('assets/img/page-header-bg.svg')no-repeat bottom right",
        }}
      />
    </Layout>
  );
};

export default HomeDesktopApp;
